import React from 'react';

import EventList from './components/EventList';

interface FiscalYear {
  startDate?: string;
  endDate?: string;
}

interface UpcomingEventsProps {
  currentFiscalYear: FiscalYear;
}

export const UpcomingEvents: React.FC<UpcomingEventsProps> = ({ currentFiscalYear }) => {
  return (
    <div className="full-scope-card dashboard__card event__card d-flex flex-direction-column">
      <div className="dashboard__title event__card--title">Upcoming Events & Holidays</div>
      {currentFiscalYear.endDate && <EventList currentFiscalYear={currentFiscalYear} />}
    </div>
  );
};
